import { render } from "./shopVipStatistics.vue?vue&type=template&id=7ba74276"
import script from "./shopVipStatistics.vue?vue&type=script&lang=js"
export * from "./shopVipStatistics.vue?vue&type=script&lang=js"

import "./shopVipStatistics.vue?vue&type=style&index=0&id=7ba74276&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__